import React from 'react';
import { DataCollectionGapSummaryComplianceRegulation } from '../../../../store/Models/Api/DataCollectionGapSummaryModels';
import { useLocalizer } from '../hooks/useLocalizer';
import {
    getRegulationRequiredQuestionAnswered,
    getRegulationRequiredQuestionUnanswered
} from './helpers/gapSummaryHelpers';
import QuestionList from './QuestionList';

interface RegulationGapGroupProps {
    regulation: DataCollectionGapSummaryComplianceRegulation;
}

export const RegulationGapGroup: React.FC<RegulationGapGroupProps> = ({ regulation }) => {
    const localize = useLocalizer();
    const requiredQuestionsAnswered = getRegulationRequiredQuestionAnswered(regulation);
    const unansweredCount = getRegulationRequiredQuestionUnanswered(regulation);
    const requiredQuestionsTotal = requiredQuestionsAnswered + unansweredCount;

    if (unansweredCount === 0) {
        return null;
    }

    return (
        <div className="gap-summary-gap-group">
            <div className="gap-summary-gap-group-title">
                <span>{regulation.name ? localize(regulation.name) : localize('Regulation')}</span>
                <span className="gap-summary-gap-group-counts">
                    {requiredQuestionsAnswered}/{requiredQuestionsTotal} {localize('answered')}
                </span>
            </div>
            <QuestionList questions={regulation.questions} />
        </div>
    );
};

export default RegulationGapGroup;
